import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild  } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Subject, debounceTime } from 'rxjs';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import { Paginator } from 'primeng/paginator';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { DialogService } from 'primeng/dynamicdialog';
import { BulkResultComponent } from 'src/app/bulk-result/bulk-result.component';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
    selector: 'app-user-listing',
    templateUrl: './user-listing.component.html',
    styleUrls: ['./user-listing.component.scss'],
    standalone: false
})
export class UserListingComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 's_no', header: 'Sl.No' },
    { field: 'first_name', header: 'Name' },
    { field: 'roles', header: 'Role' },
    { field: 'email', header: 'Email Id' },
    { field: 'contact_number', header: 'Mobile No' },
    { field: 'created', header: 'Created On', pipe: 'date:dd MMM yyyy' },
    { field: 'is_active', header: 'Status' },
    { field: 'is_approver', header: 'Approver' },
    { field: 'action', header: 'Action', toggleable: false },
  ];

  selectedState: any;
  amountbalance = '2.5cr';
  selectedDate: any;
  userData: any = [];
  pageNo: number = 0;
  rowsPerPage: number = 10;
  totalRecords: number = 10;
  displayBranch!: any;
  userExcelData;
  searchText: string = '';
  onSearchTextChange: Subject<string> = new Subject<string>();
  userFilters: any = { search: '' };
  @ViewChild('paginator', { static: false }) paginator: Paginator;
  fileUrl: string;
  fileName: string;
  selectedFile: any;
  userRole: string;
  // Logged-in user's email (stored at login), used to find their own row.
  loggedInEmail: string = '';
  showApproverEmails:boolean=false;
  roles: any = [
    'ORGANISATION-ADMIN',
    'IT-ADMIN',
    'ACCOUNT-ADMIN',
    'BRANCH-ADMIN',
    'CLIENT',
  ];
  roleHierarchy: { [role: string]: number } = {
    'ORGANISATION-ADMIN': 1,
    'IT-ADMIN': 1,
    'ACCOUNT-ADMIN': 2,
    'BRANCH-ADMIN': 3,
    'CLIENT': 3,
    'OPERATOR': 3,
    'ADMIN': 3,
  };
  // Only these roles may toggle status or edit other users; everyone else has no permission at all.
  actionableRoles = ['ORGANISATION-ADMIN', 'IT-ADMIN', 'ACCOUNT-ADMIN'];
  pagenumber: number;
  pageCount: number;
  showCalendar = false;
  rangeDates: Date[] | undefined;
  maxDate = new Date();
  constructor(
    private router: Router,
    private messageService: MessageService,
    private exportExcelService: ExportExcelService,
    private storageService: StorageService,
    private http: HttpClient,
    private userManagementService: UserManagementService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef

     
  ) {
    this.onSearchTextChange.pipe(debounceTime(1500)).subscribe((value) => {
      this.userFilters.search = value;
      this.getUserDetails();
    });
  
    

    this.userRole = this.storageService.getRole() || null;
    this.loggedInEmail = String(this.storageService.getLoginEmail() ?? '')
      .trim()
      .toLowerCase();
  }

  ngOnInit(): void {
    this.getUserDetails();
  }

  gotoDashboard() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  export() {
    //  this.exportExcelService.convertToExcel(this.userData, 'userData');
    let data = {};
    this.exportExcelService.getUserManagement(data).subscribe((res) => {
      if (res) {
        this.exportExcelService.base64ToCSV(res['content'], 'USER_REPORT');
        this.messageService.add({
          severity: 'success',
          summary: 'File downloaded successfully !',
          icon: 'pi-check-circle',
        });
      }
    });
  }
  showSuccess() {
    this.messageService.add({
      severity: 'custom',
      summary: 'User deleted successfully!',
      icon: 'pi-check-circle',
    });
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  getUserDetails() {
    this.userManagementService
      .getUserData(this.userFilters)
      .subscribe((resp: any) => {
        if (resp.status == 200) {
          if (resp.content.length != 0) {
            this.userData = resp['content'];
            this.totalRecords = resp.pagination.total_records;
            this.pagenumber = resp.pagination.previous_page_number;

            if (this.pagenumber) {
              this.pageCount = this.pagenumber * this.userFilters['page_size'];
            } else {
              this.pageCount = 0;
            }
          } else {
            this.userData = resp.content;
            this.totalRecords = 0;
          }
          this.cdr.detectChanges();
        }
      });
  }

  // Approver column only (unchanged). The Status column uses canChangeStatus().
   canToggleStatus(userRoles: string[]): boolean {
     const allowedRoles = ['ORGANISATION-ADMIN', 'ACCOUNT-ADMIN'];
  return userRoles.some((role: string) => allowedRoles.includes(role));
  }

  /**
   * Status column permission, based on who is logged in (not on the row's role):
   *  - Nobody can change the status of their own account, whatever their role.
   *  - Organisation Admin: every other user.
   *  - Account Admin: every other user except Organisation Admins.
   *  - Any other role: no one.
   */
  canChangeStatus(user: any): boolean {
    if (this.isLoggedInUser(user)) {
      return false;
    }

    const rowRoles: string[] = Array.isArray(user?.roles) ? user.roles : [];

    if (this.userRole === 'ORGANISATION-ADMIN') {
      return true;
    }
    if (this.userRole === 'ACCOUNT-ADMIN') {
      return !rowRoles.includes('ORGANISATION-ADMIN');
    }
    return false;
  }

  /** True when the row is the logged-in user's own account (matched by email). */
  private isLoggedInUser(user: any): boolean {
    const rowEmail = String(user?.email ?? '').trim().toLowerCase();
    return !!rowEmail && rowEmail === this.loggedInEmail;
  }

  /**
   * A locked Status toggle is disabled, so its own click handler never runs.
   * The click still reaches the surrounding label, so the message is shown from here.
   */
  notifyIfStatusLocked(user: any): void {
    if (!this.canChangeStatus(user)) {
      this.messageService.add({
        severity: 'warn',
        detail: "You don't have permission to edit",
      });
    }
  }

toggleUserStatus(user:any) {
  // Never call the API for a row the logged-in user isn't allowed to change.
  if (!this.canChangeStatus(user)) {
    return;
  }
  const payload = {
    user_id: user.id,
      is_approver: user.is_approver,
      is_user_active: !user.is_active
  };

  this.userManagementService.toggleUserStatus(payload)
    .subscribe((res:any)=>{ 
      user.is_active = payload.is_user_active;
      this.cdr.detectChanges();
    });

}
  onPageChange(event: any) {
    this.pageNo = event.first;
    this.userFilters['page_number'] = event.page + 1;
    this.userFilters['page_size'] = event.rows;
    this.getUserDetails();
  }
  detectXssInUserData(data: any[]): {
    hasXss: boolean;
    maliciousFields: string[];
  } {
    const xssPatterns = [
      /<script/i,
      /<\/script>/i,
      /javascript:/i,
      /onerror=/i,
      /onload=/i,
      /onclick=/i,
      /<iframe/i,
      /<object/i,
      /<embed/i,
      /<img[^>]*on/i,
      /eval\(/i,
      /%3cscript/i,
      /&lt;script/i,
    ];

    const maliciousFields: string[] = [];
    let hasXss = false;

    const fieldsToValidate = [
      'first_name',
      'last_name',
      'email',
      'password',
      'confirm_password',
    ];

    data.forEach((row, rowIndex) => {
      fieldsToValidate.forEach((field) => {
        if (row[field]) {
          const value = row[field].toString().toLowerCase().trim();
          const isMalicious = xssPatterns.some((pattern) =>
            pattern.test(value)
          );

          if (isMalicious) {
            hasXss = true;
            const rowNumber = rowIndex + 2;
            maliciousFields.push(`Row ${rowNumber}, Column "${field}"`);
          }
        }
      });
    });

    return { hasXss, maliciousFields };
  }

  onFileChange(event: any) {
    let workBook;
    let jsonData;
    const reader = new FileReader();
    const file = event.target.files[0];
    this.selectedFile = file;

    reader.onload = () => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});

      this.userExcelData = jsonData.Sheet1;

      if (this.userExcelData.length === 0) {
        this.messageService.add({
          detail: 'No data found in excel. Please fill and upload again',
        });
        return;
      }

      const xssCheck = this.detectXssInUserData(this.userExcelData);

      if (xssCheck.hasXss) {
        const locations = xssCheck.maliciousFields.slice(0, 3).join('; ');
        const moreText =
          xssCheck.maliciousFields.length > 3
            ? ` and ${xssCheck.maliciousFields.length - 3} more`
            : '';

        this.messageService.add({
          severity: 'error',
          summary: 'Security Alert',
          detail: `Malicious content detected in: ${locations}${moreText}. Script tags are not allowed.`,
        });
        this.clearFile();
        return;
      }

       const hasInvalidRole = this.userExcelData.some((row: any) => {
        // Use row.roles or row.Roles to be safe with casing
        const roleValue = row.roles || row.Roles; 
        return roleValue && typeof roleValue === 'string' && roleValue.includes('_');
      });

      if (hasInvalidRole) {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Role Format',
          detail: 'Roles cannot contain underscores (_). Please use hyphens (-) instead (e.g., "organisation-admin") and upload again.',
        });
        this.clearFile();
        return;
      }

      this.userManagementService
        .createUser(this.userExcelData)
        .subscribe((res: any) => {
          if (res.status == 201) {
            this.dialogService.open(BulkResultComponent, {
              header: 'Bulk Upload Results',
              width: '40%',
              style: {
                'min-height': '30vh',
                'max-height': '80vh',
                height: 'auto',
              },
              data: {
                success: res.content?.success || [{ message: res.message || 'User created successfully' }],
                errors: res.content?.errors || [],
                entityType: 'Users',
              },
            });
            this.getUserDetails();
            this.clearFile();
          }
        });
    };
    reader.readAsBinaryString(file);
  }

  onChangeSearchText(value) {
    this.searchText = value.toString();
    this.onSearchTextChange.next(value);
  }

  clearPaginationFilter() {
    this.userFilters['page_number'] = 1;
    this.userFilters['page_size'] = 10;
    if (this.userData.length != 0) this.paginator.changePage(0);
  }

  template() {
    this.fileUrl = 'assets/Sample_Files_Bulk_Upload/bulk_user.xlsx';
    this.fileName = 'bulk_user_upload.xlsx';
    this.http
      .get(this.fileUrl, { responseType: 'blob' })
      .subscribe((response: Blob) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(response);
        downloadLink.download = this.fileName;
        downloadLink.click();
      });
  }

  clearFile() {
    this.selectedFile = '';
    const inputElement = <HTMLInputElement>(
      document.getElementById('upload_file')
    );
    inputElement.value = null;
  }

  editUser(user: any) {
    user.roles = user.roles.filter((role: string) => role !== 'OPS-ADMIN');
    const currentUserRole = user.roles[0];
    const currentUserRoleLevel = this.roleHierarchy[currentUserRole];
    const canEdit =
      this.actionableRoles.includes(this.userRole) &&
      this.roleHierarchy[this.userRole] <= currentUserRoleLevel;
    if (canEdit) {
      this.router.navigate([`/doqfy/management/user-edit/${user.id}`]);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Edit User',
        detail: 'You do not have permission to edit this user !',
      });
    }
  }

  openCalendar() {
    this.showCalendar = true;
  }

  cancelCalendar() {
    this.showCalendar = false;
    this.rangeDates = undefined;
  }

  onDateSelect(event: any) {
    console.log('Selected Dates:', this.rangeDates);
  }

  downloadActivity() {
    if (!this.rangeDates || this.rangeDates.length < 2) return;

    const [start, end] = this.rangeDates;
    const payload = {
      start_date: this.formatDate(start),
      end_date: this.formatDate(end),
    };

    console.log('Payload:', payload);
    this.userManagementService
      .getUserActivityReport(payload)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.userManagementService.downloadBase64File(
            res.content.file_data,
            res.content.filename,
            res.content.file_type
          );

          setTimeout(() => {
            this.messageService.add({
              severity: 'success',
              detail: 'File downloaded successfully',
            });
          }, 500);
        }
      });
  }

  private formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

 sanitizeSearchText(event: any) {
  const input = event.target as HTMLInputElement;
  // Allow only alphanumeric characters and spaces
  const sanitized = input.value.replace(/[^A-Za-z0-9 ]/g, '');
  
  if (input.value !== sanitized) {
    this.searchText = sanitized;
    input.value = sanitized;
  }
 }

  toggleApprover(user: any) {
   const payload = {
    user_id: user.id,
    is_approver: !user.is_approver,
    is_user_active: user.is_active
  };
  this.userManagementService.toggleUserStatus(payload)
    .subscribe((res:any)=>{
        user.is_approver = payload.is_approver;
        this.cdr.detectChanges();
  })
}

@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  const target = event.target as HTMLElement;

  if (!target.closest('.approver-email-wrapper')) {
    this.showApproverEmails = false;
  }
}
}



